class VariantSelector extends HTMLElement {
  constructor() {
    super();

    const params = new URLSearchParams(window.location.search);
    this.variantFromUrl = params.get('variant');

    this.url = this.dataset.url ? this.dataset.url : "mitopets-pad";
    this.CurrentPrice = document.querySelector('.price-item');
    this.FeaturedPrice = this.querySelector('.price-item2');
    this.productId = document.querySelector('.product-variant-id');
    this.pet_product_id = document.querySelector('.product-variant-id-2');
    this.buyButton = document.querySelector('.product-form__buttons > button');
  }

  connectedCallback() {
    this.rawdata = this.querySelector('script')?.innerText;

    if (this.rawdata) {
      this.data = JSON.parse(this.rawdata);
      if (this.data.meta) this.GroupedMetaData(this.data.meta);
    }

    this.options = this.querySelectorAll('button');

    if (this.options.length > 1) {
      this.setDefaultVariant();   // ✅ FIX: default variant
      this.onloadCheck();
      this.addListeners();
    } else {
      this.getVariantImages();
    }
  }

  /* ================= NORMALIZER (CRITICAL) ================= */
  normalize(str) {
    if (!str) return "";
    return str
      .normalize("NFKD")
      .replace(/\u00A0/g, " ")
      .replace(/[|｜]/g, "|")
      .replace(/[–—]/g, "-")
      .replace(/\s+/g, " ")
      .trim();
  }

  /* ================= DEFAULT VARIANT FIX ================= */
  setDefaultVariant() {
    let selected = this.querySelector('button.is-selected');

    if (!selected) {
      selected = this.variantFromUrl
        ? this.querySelector(`button[data-variant-id="${this.variantFromUrl}"]`)
        : this.querySelector('button[data-variant-alt]');

      if (selected) selected.classList.add('is-selected');
    }

    if (selected?.dataset.variantAlt) {
      this.getVariantImages(this.normalize(selected.dataset.variantAlt));
    }

    if (selected?.dataset.price && this.CurrentPrice) {
      this.CurrentPrice.innerText = this.formatPrice(selected.dataset.price);
    }
  }

  /* ================= EVENT LISTENERS ================= */
  addListeners() {
    this.options.forEach(option => {
      option.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('variant', option.dataset.variantId);
        window.history.replaceState({}, '', `${this.url}?${params.toString()}`);

        this.clearSelection();
        option.classList.add('is-selected');

        if (!option.classList.contains('pets_var')) {
          this.CurrentPrice.innerText = this.formatPrice(option.dataset.price);
          if (this.productId) this.productId.value = option.dataset.variantId;
        }

        if (option.dataset.variantAlt) {
          this.getVariantImages(this.normalize(option.dataset.variantAlt));
        }
      });
    });
  }

  clearSelection() {
    this.options.forEach(option => option.classList.remove('is-selected'));
  }

  onloadCheck() {
    this.options.forEach(option => {
      if (option.classList.contains('is-selected') && option.dataset.variantAlt) {
        this.getVariantImages(this.normalize(option.dataset.variantAlt));
      }
    });
  }

  /* ================= IMAGE MATCHING (FIXED) ================= */
  getVariantImages(variant) {
    const title = this.normalize(
      document.querySelector('.product-title')?.textContent
    );

    const images = document.querySelectorAll('.product__gallery__main__media');

    if (variant) {
      images.forEach(image => {
        const alt = this.normalize(image.dataset.alt);

        if (alt.startsWith(variant) || alt === title) {
          image.classList.remove('hidden');
          document.getElementById(image.dataset.mediaId).style.display = "block";
        } else {
          image.classList.add('hidden');
          document.getElementById(image.dataset.mediaId).style.display = "none";
        }
      });
    } else {
      images.forEach(image => {
        image.classList.remove('hidden');
        document.getElementById(image.dataset.mediaId).style.display = "block";
      });
    }
  }

  /* ================= VARIANT BUTTON RENDER ================= */
  GroupedMetaData(meta) {
    const grouped = meta.reduce((acc, item) => {
      const key = item.option_group;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    if (Object.keys(grouped).length) this.PrintTitle(grouped);
  }

  PrintTitle(groupedData) {
    const parent = $(this.querySelector('.display-flex'));

    for (const group in groupedData) {
      const $group = $('<div class="buttons-group"></div>');
      parent.append($group);

      groupedData[group].forEach(item => {
        $group.append(`
          <button
            data-price="${item.price}"
            data-variant-id="${item.variant_id}"
            data-variant-alt="${item.title}">
            ${item.title}
          </button>
        `);
      });
    }
  }

  formatPrice(priceInCents) {
    const dollars = priceInCents / 100;
    return `$${dollars.toLocaleString("en-US")}`;
  }
}

customElements.define('custom-variant-selector', VariantSelector);